module.exports = __webpack_public_path__ + "static/media/kiwi.bec93f63.png";